import React from "react"

const Footer = () => {
    return (
        <footer>
            <div className="container"><span className="footer-name">bmsteven</span><span className="copyright">&copy;&nbsp;2019</span></div>
        </footer>
    );
}

export default Footer;